import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  wrap: {
    // width: 311,
    position: 'fixed',
    width: 648,
    height: 400,
    bottom: 24,
    right: 24,
    padding: 30,
    backgroundColor: theme.palette.background.paper,
    overflow: 'hidden',
    borderRadius: '2px',
    boxShadow: '0 24px 24px 0 rgba(0, 0, 0, 0.3), 0 0 24px 0 rgba(0, 0, 0, 0.22)',
    zIndex: 3,
  },
  subtitle: {
    fontSize: 12,
    fontWeight: 500,
    color: theme.palette.text.primary,
    opacity: 0.54,
  },
  tableWrap: {
    border: '1px solid #dbdbdb',
    borderRadius: 3,
    height: 192,
    overflow: 'scroll',
  },
  paginationToolbar: {
    minHeight: 44,
  },
  paginationIconButton: {
    padding: 6,
  },
  contentRow: {
    height: 48,
  },
  contentDesc2: {
    fontSize: 11,
    color: '#aaa',
    lineHeight: 1.2,
  },
  buttonWrap: {
    paddingTop: 24,
    marginRight: -4,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  reviewStatus: {
    fontSize: 12,
    textTransform: 'capitalize',
    color: '#666',
  },
  approve: {
    color: theme.palette.primary.main,
  },
  fatal: {
    color: '#d0021b',
  },
}));

export default useStyles;
